<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo">
        <img class="logo-icon" *ngIf="fuseConfig.layout.navbar.laftNavigationTopLogo" [src]="fuseConfig.layout.navbar.laftNavigationTopLogo">
        <!--secondary-text-->
        <span class="logo-text primary" *ngIf="fuseConfig.workingDomain">{{fuseConfig.workingDomain|| 'SELISE'}}</span>
    </div>

    <div class="buttons">

        <button mat-icon-button class="toggle-sidebar-folded"
                (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="primary">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened"
                (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="primary">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

        <div class="h3 username primary" *ngIf="fuseConfig.layout.navbar.userNameShow">
            {{userInfo.DisplayName || 'USER NAME'}}</div>
        <div class="h5 email primary mt-8" *ngIf="fuseConfig.layout.navbar.designationText">
            {{fuseConfig.layout.navbar.designationText || 'Designation'}}</div>
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="{{basicUserInfo?.ProfileImage}}">
        </div>

    </div>

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

</div>